import { getTracking } from '../selectors/getTracking'
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import TrackingLib from '@gameday/tracking/GamedayTracking';

export default  () => {
    const tracking = useSelector(getTracking);

    return useMemo(() => {
        TrackingLib.setProps(tracking);
        TrackingLib.init();
        return TrackingLib;
    }, [tracking]);
};
